/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
	{
		_id: "TlZwCVCuSEE",
		title: "Stars crush Hurricanes as Maxwell makes history | BBL|11",
		channelName: "cricket.com.au",
		thumbnail: "https://i3.ytimg.com/vi/TlZwCVCuSEE/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSaliAXEasGek2J2eYdjkofH1rvdqZ4V320tT-NVRU=s88-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "4.9M views",
		likes: "114k",
		time: "11.49",
		category: "BBL",
	},

	{
		_id: "FEk6TEJSll8",
		title: "Semi Final 1 | Trinbago Knight Riders vs Saint Lucia Kings",
		channelName: "CPL T20",
		thumbnail: "https://i3.ytimg.com/vi/FEk6TEJSll8/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/yRMhS5M9ZV9nFW4vr5sNcnGxCgNgKEJ20dFKGYwL6vO73z0O26HwJ7VJV_B6rGW9ulGBzY_YJg=s176-c-k-c0x00ffffff-no-rj-mo",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "918k views",
		likes: "18k",
		time: "8.03",
		category: "CPL T20",
	},
	{
		_id: "KA4n5wej5Qc",
		title: "10 Sixes for Livingstone! | The Hundred 21",
		channelName: "The Hundred",
		thumbnail: "https://i3.ytimg.com/vi/KA4n5wej5Qc/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRIZViEjjCoFajSaJY_7A4MDNloQ8ngQ7FgmLlF=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "820k views",
		likes: "16k",
		time: "14.46",
		category: "The Hundred",
	},
	{
		_id: "AFEZzf9_EHk",
		title: "Rohit Sharma Hits 140! | India v Pakistan | ICC CWC 2019",
		channelName: "ICC",
		thumbnail: "https://i3.ytimg.com/vi/AFEZzf9_EHk/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQW1DW8YJh1nhWtC3uVnvqZ4lzjiMXUoxbp_U4mfjs=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "90M views",
		likes: "716k",
		time: "6.14",
		category: "ICC",
	},
	{
		_id: "jJUBYUeJ0l0",
		title: "The FINAL | Deccan Gladiators vs Delhi Bulls | Abu Dhabi T10",
		channelName: "T10 League Official",
		thumbnail: "https://i3.ytimg.com/vi/jJUBYUeJ0l0/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/qEjZkQtskTBkX4wq-Br4Z9OG9QOVJto_O3rSpYaa_8FzImGunyam7rTnMXMFZl4ymQjalU4A=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "2M views",
		likes: "40k",
		time: "22.00",
		category: "T10 League",
	},
	{
		_id: "iV1AdFS-Zak",
		title: "Perth Scorchers vs Sydney Sixers | Highlights | BBL | Final |",
		channelName: "cricket.com.au",
		thumbnail: "https://i3.ytimg.com/vi/iV1AdFS-Zak/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSaliAXEasGek2J2eYdjkofH1rvdqZ4V320tT-NVRU=s88-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.09M views",
		likes: "25k",
		time: "16.05",
		category: "BBL",
	},
	{
		_id: "BNbNKygcG-A",
		title: "Semi Final 2 | Guyana Warriors vs St Kittis | CPL 2021",
		channelName: "CPL T20",
		thumbnail: "https://i3.ytimg.com/vi/BNbNKygcG-A/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/yRMhS5M9ZV9nFW4vr5sNcnGxCgNgKEJ20dFKGYwL6vO73z0O26HwJ7VJV_B6rGW9ulGBzY_YJg=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.3 views",
		likes: "40k",
		time: "8.03",
		category: "CPL T20",
	},
	{
		_id: "SomR0nVmi9w",
		title: "Southern Brave Are Champions! | The Hundred 2021",
		channelName: "The Hundred",
		thumbnail: "https://i3.ytimg.com/vi/SomR0nVmi9w/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRIZViEjjCoFajSaJY_7A4MDNloQ8ngQ7FgmLlF=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "824k views",
		likes: "17k",
		time: "14.51",
		category: "The Hundred",
	},
	{
		_id: "8b0ubLO2MUE",
		title: "Yuvraj Singh slams six sixes off Stuart Broad | T20 World Cup 2007",
		channelName: "ICC",
		thumbnail: "https://i3.ytimg.com/vi/8b0ubLO2MUE/hqdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQW1DW8YJh1nhWtC3uVnvqZ4lzjiMXUoxbp_U4mfjs=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "63M views",
		likes: "1.1M",
		time: "6.44",
		category: "ICC",
	},
	{
		_id: "EZbIJxVMHDk",
		title: "Deccan Gladiators vs Team Abu Dhabi | Abu Dhabi T10 Season 5",
		channelName: "T10 League Official",
		thumbnail: "https://i3.ytimg.com/vi/EZbIJxVMHDk/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/qEjZkQtskTBkX4wq-Br4Z9OG9QOVJto_O3rSpYaa_8FzImGunyam7rTnMXMFZl4ymQjalU4A=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.9M views",
		likes: "28k",
		time: "22.00",
		category: "T10 League",
	},
	{
		_id: "JRBhVA6oVdw",
		title: "Sixers thrash Stars in record-breaking display | BBL|11",
		channelName: "cricket.com.au",
		thumbnail: "https://i3.ytimg.com/vi/JRBhVA6oVdw/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSaliAXEasGek2J2eYdjkofH1rvdqZ4V320tT-NVRU=s88-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.6 views",
		likes: "40k",
		time: "8.29",
		category: "BBL",
	},
	{
		_id: "6oQo8lf5USM",
		title: "Final | Saint Lucia Kings vs St. Kitts & Nevis Patriots | CPL 2021",
		channelName: "CPL T20",
		thumbnail: "https://i3.ytimg.com/vi/6oQo8lf5USM/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/yRMhS5M9ZV9nFW4vr5sNcnGxCgNgKEJ20dFKGYwL6vO73z0O26HwJ7VJV_B6rGW9ulGBzY_YJg=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.3M views",
		likes: "32k",
		time: "8.03",
		category: "CPL T20",
	},
	{
		_id: "3RtbHPSr8HU",
		title: "Oval Invincibles vs Manchester Originals | The Hundred 2021",
		channelName: "The Hundred",
		thumbnail: "https://i3.ytimg.com/vi/3RtbHPSr8HU/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRIZViEjjCoFajSaJY_7A4MDNloQ8ngQ7FgmLlF=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.2M views",
		likes: "28k",
		time: "15.26",
		category: "The Hundred",
	},
	{
		_id: "fBIqzpkaIy8",
		title: "Biggest Sixes! | ICC Cricket World Cup 2019",
		channelName: "ICC",
		thumbnail: "https://i3.ytimg.com/vi/fBIqzpkaIy8/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQW1DW8YJh1nhWtC3uVnvqZ4lzjiMXUoxbp_U4mfjs=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "7M views",
		likes: "125k",
		time: "2.16",
		category: "ICC",
	},
	{
		_id: "zXddZxAkXz4",
		title: "Bangla Tigers vs Team Abu Dhabi | Day 1 | Abu Dhabi T10 | Season 5",
		channelName: "T10 League Official",
		thumbnail: "https://i3.ytimg.com/vi/zXddZxAkXz4/hqdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/qEjZkQtskTBkX4wq-Br4Z9OG9QOVJto_O3rSpYaa_8FzImGunyam7rTnMXMFZl4ymQjalU4A=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "1.7M views",
		likes: "34k",
		time: "22.00",
		category: "T10 League",
	},
	{
		_id: "6xiQcBhEtnw",
		title: "Hurricanes knock off defending champs in KFC BBL 10 opener",
		channelName: "cricket.com.au",
		thumbnail: "https://i3.ytimg.com/vi/6xiQcBhEtnw/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSaliAXEasGek2J2eYdjkofH1rvdqZ4V320tT-NVRU=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "4M views",
		likes: "77k",
		time: "7.54",
		category: "BBL",
	},
	{
		_id: "Qv6eRZ2hQ9E",
		title: "Odean Smith Breaking Bats & Smashing Sixes!",
		channelName: "CPL T20",
		thumbnail: "https://i3.ytimg.com/vi/Qv6eRZ2hQ9E/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/yRMhS5M9ZV9nFW4vr5sNcnGxCgNgKEJ20dFKGYwL6vO73z0O26HwJ7VJV_B6rGW9ulGBzY_YJg=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "4.1M views",
		likes: "34k",
		time: "5.10",
		category: "CPL T20",
	},
	{
		_id: "gQCNYyDbew0",
		title: "Biggest Total Yet! | London Spirit v Northern Superchargers",
		channelName: "The Hundred",
		thumbnail: "https://i3.ytimg.com/vi/gQCNYyDbew0/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRIZViEjjCoFajSaJY_7A4MDNloQ8ngQ7FgmLlF=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "313k views",
		likes: "5.9k",
		time: "14.52",
		category: "The Hundred",
	},
	{
		_id: "Kwu1yIC-ssg",
		title: "England Win CWC After Super Over! | ICC Cricket World Cup 2019",
		channelName: "ICC",
		thumbnail: "https://i3.ytimg.com/vi/Kwu1yIC-ssg/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQW1DW8YJh1nhWtC3uVnvqZ4lzjiMXUoxbp_U4mfjs=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "44M views",
		likes: "367k",
		time: "8.09",
		category: "ICC",
	},

	{
		_id: "HkR5u-zoxjM",
		title: "The Chennai Braves vs Team Abu Dhabi | Abu Dhabi T10 Season 5",
		channelName: "T10 League Official",
		thumbnail: "https://i3.ytimg.com/vi/HkR5u-zoxjM/maxresdefault.jpg",
		channelAvatar:
			"https://yt3.ggpht.com/qEjZkQtskTBkX4wq-Br4Z9OG9QOVJto_O3rSpYaa_8FzImGunyam7rTnMXMFZl4ymQjalU4A=s48-c-k-c0x00ffffff-no-rj",
		description:
			"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
		videoViews: "783k views",
		likes: "14k",
		time: "21.44",
		category: "T10 League",
	},
];
